/**
 * Helpers for the hierarchy returned by GET /api/trainer/team.
 *
 * That endpoint answers with two different shapes (backend/routers/trainer.py):
 *
 *   - solo tenant  → `tree` already starts at the signed-in trainer's children
 *   - firm member  → `tree` is the WHOLE firm, rooted at its owner, so a
 *                    mid-level trainer finds themselves nested inside it,
 *                    next to their peers and below their manager
 *
 * Both the clients list and the team view are meant to show only what is
 * *under* the signed-in trainer — their manager and peers belong to neither.
 * Reading `tree` as-is silently mixes the two shapes: a head coach's own
 * clients get listed twice, and a junior trainer is shown the entire company.
 */

/**
 * The sub-trainers directly under `userId`, wherever that trainer sits in the
 * tree. Falls back to `tree` itself when the trainer is not in it, which is the
 * solo shape — there `tree` is already the list of their children.
 */
export function ownSubTree(tree, userId) {
  const find = (nodes) => {
    for (const node of nodes) {
      if (node.id === userId) return node.sub_trainers || [];
      const hit = find(node.sub_trainers || []);
      if (hit) return hit;
    }
    return null;
  };
  return find(tree || []) || tree || [];
}
